<mat-card *ngIf="page_flag">

    <mat-tab-group mat-stretch-tabs="false" class="over">

        <mat-tab label="Kalyan mandap Lists"> <br>
            <div *ngIf="list_flag">
                <div class="d-flex justify-content-between mb-3">
                    <div class="filter d-flex">
                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                        <input class="input-filter" placeholder="Search by Name, Letter and Number"
                            (keyup)="applyFilter($any($event.target).value)">
                    </div>

                    <div class="export_btn">
                        <button class="btn_export" (click)="export()">Export</button>
                    </div>
                    <button class="btn_create" (click)="open_create()">
                        Create
                    </button>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="datasource" matSort>
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}</td>
                        </ng-container>
                        <ng-container matColumnDef="kalyan_mandap_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Kalyan Mandap Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.klm_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Address</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.street_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="capacity">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Capacity</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element['max_people']}}</td>
                        </ng-container>
                        <ng-container matColumnDef="booking_amt">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Booking Amount</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.amount}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.status}}</td>
                        </ng-container>


                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element">
                                <div style="display: flex; align-items: center;">
                                    <i class="fa fa-eye hhh" (click)="open_application(element)"
                                        aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div class="showonhover">
                                        <i class="fa fa-ellipsis-v hhh"
                                            (click)="toggleHoverText($event)" aria-hidden="true"></i>
                                        <span class="hovertext">
                                            <ul>
                                                <li class="hh_tt" (click)="View_details(element)">
                                                    <h6>View Details</h6>
                                                </li>
                                                <li class="hh_tt" (click)="edit_Details(element)">
                                                    <h6>Edit Details </h6>
                                                </li>
                                                <li class="hh_tt" (click)="manage_avilable(element)">
                                                    <h6>Manage availability </h6>
                                                </li>
                                                <li class="hh_tt" *ngIf="element.status=='ACTIVE'" (click)="deactivate_klm(element)">
                                                    <h6>Deactivate </h6>
                                                </li>
                                                <li class="hh_tt" *ngIf="element.status=='INACTIVE'" (click)="activate_klm(element)">
                                                    <h6>Activate </h6>
                                                </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </td>
                            


                            <!-- <td mat-cell flex-stretch *matCellDef="let element" class="right">

                                <button class="btn btn-outline-primary" (click)="view_detail(element)">View
                                    Details</button>
                            </td> -->
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator  #paginator0  [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>




            <div *ngIf="create_flag">
                <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="Kalyan mandap Details" completed="false">
                        <br>
                        <div class="row">

                            <div class="upload-container">
                                <div class="upload-box">

                                    <!-- <input #uploaddocument type="file" multiple="true" accept="application/pdf"
                                    class="upload-box form-control" style="border-color: black"
                                    (change)="uploaddoc($event)"> -->

                                    <label for="fileInput">
                                        <img src="./../../../assets/Group.png" alt="Upload Icon" class="upload-icon" />
                                        <span class="upload-text" style="color:black">Upload Photos</span>
                                    </label>
                                    <input #uploaddocument class="upload-box form-control" type="file" id="fileInput"
                                        multiple accept="image/png, image/jpeg" (change)="onFileSelected($event)" />
                                </div>
                                <p class="upload-instructions text-center">You can upload up to 6 photos, each with a
                                    maximum size
                                    of 2MB. Accepted formats are PNG and JPG.</p>
                            </div>
                        </div>


                        <br><br>
                        <div class="row">
                            <div class="col-3">
                                <label class="form-label">Kalyan Mandap Name <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter Full name"
                                    [(ngModel)]="klmmangObj['klm_name']">
                            </div>
                            <div class="col-3">
                                <label class="form-label">Max People <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Select Capacity"
                                    [(ngModel)]="klmmangObj['max_people']">
                            </div>
                            <div class="col-3">
                                <label class="form-label">Measurement Unit <span style="color:red"> * </span> </label>
                                <input type="number" class="form-control" placeholder="Select Unit"
                                    [(ngModel)]="klmmangObj['unit']">
                            </div>
                            <div class="col-3">
                                <label class="form-label">Size of Kalyan Mandap <span style="color:red"> * </span>
                                </label>
                                <input type="number" class="form-control" placeholder="Enter Size"
                                    [(ngModel)]="klmmangObj['size']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4">
                                <label class="form-label">Booking Duration <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Select Duration"
                                    [(ngModel)]="klmmangObj['booking_duration']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Check-in Time <span style="color:red"> * </span></label>
                                <input type="time" class="form-control" placeholder="Enter Check-in Time"
                                    [(ngModel)]="klmmangObj['check_in_time']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Check-out Time <span style="color:red"> * </span></label>
                                <input type="time" class="form-control" placeholder="Enter Check-out Time"
                                    [(ngModel)]="klmmangObj['check_out_time']">
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="col-12 text-left">
                                <label class="form-label">Description <span style="color:red"> * </span></label>
                                
                                <textarea type="text-area" class="form-control" placeholder="Enter Description"
                                    [(ngModel)]="klmmangObj['klm_desc']"></textarea>
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="col-4">

                                <label class="form-label">Parking <span style="color:red"> * </span> </label>
                                <!-- <input type="text" class="form-control" placeholder="Enter Parking" [(ngModel)]="klmmangObj['klm_park']"> -->
                                <ng-select [items]="status" bindLabel="value" bindValue="code" [multiple]="false"
                                    placeholder="Enter Parking" [(ngModel)]="klmmangObj['is_parking']"
                                    [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true">
                                </ng-select>
                            </div>
                            <div class="col-4">

                                <label class="form-label">Ground <span style="color:red"> * </span> </label>
                                <!-- <input type="text" class="form-control" placeholder="Enter Ground"
                                    [(ngModel)]="klmmangObj['klm_grnd']"> -->
                                <ng-select [items]="status" bindLabel="value" bindValue="code" [multiple]="false"
                                    placeholder="Enter Ground" [(ngModel)]="klmmangObj['is_ground']"
                                    [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true">
                                </ng-select>

                            </div>
                            <div class="col-4">

                                <label class="form-label">Stage Set <span style="color:red"> * </span> </label>
                                <!-- <input type="text" class="form-control" placeholder="Enter Stage Set"
                                    [(ngModel)]="klmmangObj['klm_stageset']"> -->

                                <ng-select [items]="status" bindLabel="value" bindValue="code" [multiple]="false"
                                    placeholder="Enter Stage Set" [(ngModel)]="klmmangObj['is_stage_set']"
                                    [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true">
                                </ng-select>
                            </div>
                        </div><br>

                        <br>
                        <div class="row">
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                            <div class="col-2 text-center">
                                <h6 id="h" style="color: brown; min-height: 20px;">
                                    Hall / Room Details :
                                </h6>
                            </div>
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                        </div>
                        <br>



                        <div class="row">
                            <div class="col-6">
                                <label class="form-label">Number of Hall<span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter Parking"
                                    (change)="number_of_hll()" [(ngModel)]="klmmangObj['no_of_hall']">
                            </div>
                            <div class="col-6">

                                <label class="form-label">Number of Room <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter Number of Room"
                                    (change)="number_of_room()" [(ngModel)]="klmmangObj['no_of_room']">

                            </div>
                        </div>



                        <br>

                        <div class="row">




                            <div class="col-6">
                                <br>
                                <br>
                                <div class="row " *ngFor="let allowance of arr; let i = index">
                                    <h5 style="color:brown;font-weight: bold;"> Number of Hall {{ i + 1
                                        }}</h5>
                                    <br>


                                    <div class="row">
                                        <div class="col-6">
                                            <label class="form-label">Size of Hall <span style="color:red"> * </span>
                                            </label>
                                            <input type="text" class="form-control" placeholder="Enter Size of Hall"
                                                [(ngModel)]="allowance['size']">
                                            <br>
                                        </div>

                                        <div class="col-6">
                                            <label class="form-label">AC / NO AC<span style="color:red"> * </span>
                                            </label>
                                            <ng-select [items]="status" bindLabel="value" bindValue="code" [multiple]="false"
                                            placeholder="Enter Room Type" [(ngModel)]="allowance['is_ac']"
                                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true">
                                        </ng-select>
                                            <!-- <input type="text" class="form-control" placeholder="Enter Room Type"
                                                [(ngModel)]="allowance['room_type']"> -->
                                        </div>
                                    </div>
                                    <br>

                                </div>
                            </div>




                            <div class="col-6">
                                <br>
                                <br>
                                <div class="row " *ngFor="let allowance of room_arr; let i = index">
                                    <h5 style="color:brown;font-weight: bold;"> Number of Room {{ i + 1
                                        }}</h5>
                                    <br>


                                    <div class="row">
                                        <div class="col-6">
                                            <label class="form-label">Size of Room <span style="color:red"> * </span>
                                            </label>
                                            <input type="text" class="form-control" placeholder="Enter Size of room"
                                                [(ngModel)]="allowance['size']">
                                            <br>
                                        </div>

                                        <div class="col-6">
                                            <label class="form-label">AC / NO AC <span style="color:red"> * </span>
                                            </label>
                                            <ng-select [items]="status" bindLabel="value" bindValue="code" [multiple]="false"
                                            placeholder="Enter Room Type" [(ngModel)]="allowance['is_ac']"
                                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true">
                                        </ng-select>
                                            <!-- <input type="text" class="form-control" placeholder="Enter Room Type"
                                                [(ngModel)]="allowance['room_type']"> -->
                                        </div>
                                    </div>
                                    <br>

                                </div>
                            </div>
                        </div>

                        <br>
                        <div class="row">
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                            <div class="col-2 text-center">
                                <h6 id="h" style="color: brown; min-height: 20px;">
                                    Address Details :
                                </h6>
                            </div>
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                        </div>
                        <br>



                        <div class="row">
                            <div class="col-6">
                                <label class="form-label">Street Name<span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter Street Name"
                                    [(ngModel)]="klmmangObj['street_name']">
                            </div>
                            <div class="col-6">

                                <label class="form-label">Zone <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter  Zone"
                                    [(ngModel)]="klmmangObj['zone']">

                            </div>
                        </div>


                        <br>
                        <div class="row">
                            <div class="col-4">

                                <label class="form-label">Picode <span style="color:red"> * </span> </label>
                                <input type="number" class="form-control" placeholder="Enter Picode"
                                    [(ngModel)]="klmmangObj['pincode']">

                            </div>
                            <div class="col-4">

                                <label class="form-label">City <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter City"
                                    [(ngModel)]="klmmangObj['city']">

                            </div>
                            <div class="col-4">

                                <label class="form-label">State <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter State"
                                    [(ngModel)]="klmmangObj['state']">

                            </div>
                        </div> <br>

                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button type="button" class="btn btn-success"
                                    (click)=open_list()>Back</button>
                                &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button type="button" class="btn btn-danger"
                                    matStepperNext>Next</button>
                                <!--Next-->


                            </div>
                        </div>
                        <br>



                    </mat-step>


                    <mat-step [stepControl]="second" label="Pricing" completed="false">
                        <br>
                        <div class="row">
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                            <div class="col-2 text-center">
                                <h6 id="h" style="color: brown; min-height: 20px;">
                                    Pricing :
                                </h6>
                            </div>
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4">
                                <label class="form-label">Enter Amount <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter Amount"
                                    [(ngModel)]="klmmangObj['amount']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Electric Amount <span style="color:red"> * </span></label>
                                <input type="number" class="form-control" placeholder="Enter Electric Amount"
                                    [(ngModel)]="klmmangObj['electric_amt']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Security Amount <span style="color:red"> * </span></label>
                                <input type="number" class="form-control" placeholder="Enter Security Amount"
                                    [(ngModel)]="klmmangObj['security_amt']">
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="col-4">
                                <label class="form-label">GST <span style="color:red"> * </span> </label>
                                <input type="text" class="form-control" placeholder="Enter GST"
                                    [(ngModel)]="klmmangObj['gst']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">GST % <span style="color:red"> * </span></label>
                                <input type="number" class="form-control" placeholder="Enter GST %"
                                    [(ngModel)]="klmmangObj['gst_percentage']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">GST Amout <span style="color:red"> * </span></label>
                                <input type="number" class="form-control" placeholder="Enter GST Amout"
                                    [(ngModel)]="klmmangObj['gst_amount']">
                            </div>
                        </div><br>

                        <div class="row" *ngIf='create_flag ==true && update_flag==true'>


                            <div class="col-11">
                                <div *ngFor="let allowance of discount_arr; let i = index">
                                    <div class="box">
                                        <i class="fas fa-dollar-sign"></i>
                                        <!-- ADD DISCOUNT TYPE {{ i + 1 
                                            }} -->
                                        <button *ngIf="i!=0" (click)="remove(i)" class="btn btn-danger btn-sm ml-2">
                                            <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                            Remove
                                        </button>
                                    </div>
                                    <br>
                                    <br>

                                    <div class="row">
                                        <div class="col-4">
                                            <label class="form-label">Discount Type <span style="color:red"> *
                                                </span> </label>
                                            <input type="number" class="form-control"
                                                placeholder="Enter Parshad Discount "
                                                [(ngModel)]="allowance['discount_method']">
                                        </div>
                                        <div class="col-4">
                                            <label class="form-label">Discount Percentage <span style="color:red"> *
                                                </span></label>
                                            <input type="text" class="form-control"
                                                placeholder="Enter Discount Percentage/Fix"
                                                [(ngModel)]="allowance['discount_rate']">
                                        </div>
                                        <div class="col-4">
                                            <label class="form-label">Price with Tax <span style="color:red"> *
                                                </span></label>
                                            <input type="number" class="form-control" placeholder="Enter Discount Price"
                                                [(ngModel)]="allowance['discount_price']">
                                        </div>
                                    </div><br>

                                </div>
                            </div>
                            <div class="col-1 text-right">
                                <button (click)="add()" class="btn btn-primary">
                                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                </button>&nbsp;
                            </div>
                            <!-- <div class="col-2"></div> -->


                        </div>

                        <!-- <div class="row">
                            <div class="col-4">
                                <label class="form-label">Parshad Discount <span style="color:red"> * </span> </label>
                                <input type="number" class="form-control" placeholder="Enter Parshad Discount "
                                    [(ngModel)]="klmmangObj['klm_prshd_discnt']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Discount Percentage/Fix <span style="color:red"> *
                                    </span></label>
                                <input type="text" class="form-control" placeholder="Enter Discount Percentage/Fix"
                                    [(ngModel)]="klmmangObj['klm_desc_perntg_fix']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Discount Price <span style="color:red"> * </span></label>
                                <input type="number" class="form-control" placeholder="Enter Discount Price"
                                    [(ngModel)]="klmmangObj['klm_descnt_price']">
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="col-4">
                                <label class="form-label">Nagar Nigam Employee Discount </label>
                                <input type="text" class="form-control"
                                    placeholder="Enter Nagar Nigam Employee Discount "
                                    [(ngModel)]="klmmangObj['klm_ngrm_nigm_emp_disc']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Discount Percentage/Fix </label>
                                <input type="text" class="form-control" placeholder="Enter Discount Percentage/Fix"
                                    [(ngModel)]="klmmangObj['klm_ngrm_nigm_emp_disc_per_fix']">
                            </div>
                            <div class="col-4">
                                <label class="form-label">Discount Price </label>
                                <input type="text" class="form-control" placeholder="EnterDiscount Price"
                                    [(ngModel)]="klmmangObj['klm_ngrm_nigm_emp_disc_price']">
                            </div>
                        </div><br> -->

                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button>
                                &nbsp;&nbsp;
                                <!--Back-->
                                <button *ngIf='create_flag ==true && update_flag==true' mat-button mat-raised-button type="button" class="btn btn-danger"
                                    matStepperNext>Next</button>
                                    <button *ngIf='create_flag ==true && update_flag==false'  mat-button mat-raised-button type="button" class="btn btn-danger"
                                    (click)="update()">Update</button>
                                <!--Next-->


                            </div>
                        </div>
                        <br>
                    </mat-step>
                    <mat-step [stepControl]="third" label="Availability" completed="false" *ngIf='create_flag ==true && update_flag==true'>
                        <div class="calendar-header">
                            <button mat-icon-button (click)="prevMonth()">
                                <mat-icon>chevron_left</mat-icon>
                            </button>
                            <h2>{{ monthNames[currentMonth] }} {{ currentYear }}</h2>
                            <button mat-icon-button (click)="nextMonth()">
                                <mat-icon>chevron_right</mat-icon>
                            </button>
                        </div>
                        <div class="calendar">
                            <div class="calendar-day" *ngFor="let day of daysOfWeek">{{ day }}</div>
                            <div *ngFor="let date of calendarDates" class="calendar-container">
                                <div class="calendar-date">
                                    <ng-container *ngIf="!isBlocked(date); else blockedTemplate">
                                        <ng-container *ngIf="selectedDate !== date && manageDate !== date">
                                            <div class="date" (click)="showManageButton(date)">{{ date.getDate() }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="selectedDate === date && manageDate !== date">
                                            <button class="manage-button"
                                                (click)="showManageButton(date); $event.stopPropagation()">Manage</button>
                                        </ng-container>
                                        <ng-container *ngIf="manageDate === date">
                                            <div class="manage-options">
                                                <label>
                                                    <input type="radio" name="availability-{{date}}" value="available"
                                                        (click)="setAvailability(date, 'available'); $event.stopPropagation()" />
                                                    Available
                                                </label>
                                                <label>
                                                    <input type="radio" name="availability-{{date}}" value="block"
                                                        (click)="setAvailability(date, 'block'); $event.stopPropagation()" />
                                                    Block
                                                </label>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #blockedTemplate>
                                        <div>
                                            {{ date.getDate() }}
                                            <br><br>
                                            <!-- <h4 class="blocked"> BLOCKED</h4> -->
                                            <button mat-raised-button
                                                style="background-color: black;color:white;border-radius: 11px;">BLOCKED</button>
                                            <button class="unblock-button"
                                                (click)="setAvailability(date, 'available'); $event.stopPropagation()">X</button>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>



                        <!-- <div id="manageAvailability" class="modal" [ngClass]="{'show': isManageAvailabilityOpen}">
                            <div class="modal-content">
                                <span class="close" (click)="closeManageAvailability()">&times;</span>
                                <p>Manage Availability for <span>{{ selectedDate }}</span></p>
                                <button (click)="openAvailabilityOptions('Available')">Available</button>
                                <button (click)="openAvailabilityOptions('Block')">Block</button>
                            </div>
                        </div>
                        
                        <div id="availabilityOptions" class="modal" [ngClass]="{'show': isAvailabilityOptionsOpen}">
                            <div class="modal-content">
                                <span class="close" (click)="closeAvailabilityOptions()">&times;</span>
                                <p>Options for <span>{{ availabilityStatus }}</span></p>
                                Add availability options here
                            </div>
                        </div> -->


                        <br>

                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button>
                                &nbsp;&nbsp;
                                <!-- Back -->
                                <button mat-button mat-raised-button type="button" class="btn btn-danger"
                                    (click)="submit()">Submit</button>
                                <!--Next-->


                            </div>
                        </div>
                        <br>
                    </mat-step>







                </mat-horizontal-stepper>
            </div>
        </mat-tab>




    </mat-tab-group>
</mat-card>

<!-- <div *ngIf="create_flag">
    <mat-card>

        <div class="row">
            <div class="col-12 text-right">
                <button class="bck" (click)="back()">Back</button> &nbsp;&nbsp;
                Back
                <button class="AMC" (click)="submit()">Confirm and Notify CTP</button>

            </div>
        </div>

    </mat-card>
</div> -->